<app-admin-sidebar></app-admin-sidebar>
<app-adminheader></app-adminheader>
<div class="dash">
  <!-- <div class="dash-loads-top">
    <button type="button" class="button search-btn fixed-btn">
      <img src="../../../assets/img/search-white.svg" />
    </button>
  </div> -->

  <form class="" [formGroup]="mappings">
    <div class="input-fileds-container">
      <div class="row">
        <div class="col-md-12">
          <mat-label>Truck No</mat-label>
          <mat-form-field appearance="fill" class="example-field">
            <input
              matInput
              [formControl]="truckControl"
              [matAutocomplete]="trucks"
              required
            />
            <mat-autocomplete
              #trucks="matAutocomplete"
              (optionSelected)="selectTruck($event.option.value)"
            >
              <mat-option
                *ngFor="let option of filteredTrucks | async"
                [value]="option"
              >
                {{ option.truck_number }}
              </mat-option>
            </mat-autocomplete>
            <mat-error>Please select any one truck.</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <mat-label>Driver Name</mat-label>
          <mat-form-field appearance="fill" class="example-field">
            <input
              matInput
              [formControl]="driverControl"
              [matAutocomplete]="drivers"
              required
            />
            <mat-autocomplete
              #drivers="matAutocomplete"
              (optionSelected)="selectDriver($event.option.value)"
            >
              <mat-option
                *ngFor="let option of filteredDriver | async"
                [value]="option"
              >
                {{ option.username }}
              </mat-option>
            </mat-autocomplete>
            <mat-error>Please select any one driver.</mat-error>
          </mat-form-field>

          <!-- <mat-form-field appearance="fill" class="example-field">
            <input
              matInput
              formControlName="driver_id"
              [matAutocomplete]="drivers"
              required
            />
            <mat-autocomplete
              #drivers="matAutocomplete"
              (optionSelected)="selectDriver($event.option.value)"
            >
              <mat-option
                *ngFor="let option of filteredDriver | async"
                [value]="option.username"
                (onSelectionChange)="selectDriver(option)"
              >
                {{ option.username }}
              </mat-option>
            </mat-autocomplete>
            <mat-error>Please select the any one driver.</mat-error>
          </mat-form-field> -->
        </div>
      </div>
      <button
        class="md-raised button buttonBlue fixed-btn"
        type="button"
        [class.spinner]="loading"
        [ngClass]="{ 'button-disabled': loading}"
        [disabled]="loading"
        (click)="addMappings($event)"
      >
        Assign
      </button>
      <div class="search">
        <input
          class="search pl-2"
          placeholder="Truck Number"
          toUppercase
          appAlphanumericOnly
          [(ngModel)]="search_Number"
          maxlength="10"
          minlength="6"
          [ngModelOptions]="{ standalone: true }"
          #newItem
          (keyup)="onInputChange(newItem)"
          (keyup.enter)="isInputValid && search(newItem.value)"
        />
        <div class="margin">
          <button
            type="button"
            class="Position"
            (click)="resetMappingList()"
            *ngIf="clear_btn"
          >
            <img src="../../../assets/img/mapping-cross.svg" alt="Clear" />
          </button>

          <button class="Position" type="button" [disabled]="!isInputValid">
            <img
              *ngIf="search_btn"
              (click)="isInputValid ? search(newItem.value) : null"
              src="../../../assets/img/mapping-search.svg"
              alt="Search"
            />
          </button>
        </div>
      </div>
    </div>
  </form>
  <div [class.spinner]="loading"></div>

  <div class="row to_container" *ngIf="!mappingList?.length && !loading">
    <h4 class="error_msg">No Records Found.</h4>
  </div>
  <table>
    <thead>
      <tr>
        <th>Truck No</th>
        <th>Name</th>
        <th>Mobile Number</th>
        <th>Mapping Date</th>
      </tr>
    </thead>
    <tbody *ngFor="let mapping of mappingList; let i = index">
      <tr>
        <td>{{ mapping.truckInfo[0]?.truck_number }}</td>
        <td>{{ mapping.driverInfo[0]?.username }}</td>
        <td>{{ mapping.driverInfo[0]?.mobile }}</td>
        <td>{{ mapping.updatedAt | date : "dd-MM-yyyy" }}</td>
        <td>
          <button (click)="deleteMapping(mapping)">
            <img src="../../../assets/img/delete-black.svg" />
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <div *ngIf="last_page && last_page > 1" class="pagination">
    <button class="btn" [disabled]="fetch_page == 1" (click)="pagination('-1')">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="btn--icon"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M15 19l-7-7 7-7"
        />
      </svg>
    </button>
    <button
      class="btn"
      [disabled]="fetch_page == 1"
      (click)="pagination('first')"
    >
      <img
        src="../../../assets/img/pagination-left.svg"
        alt=""
        class="btn--icon"
      />
    </button>
    <div class="pages">
      <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
    </div>
    <button
      class="btn"
      [disabled]="last_page == fetch_page"
      (click)="pagination('last')"
    >
      <img
        src="../../../assets/img/pagination-right.svg"
        alt=""
        class="btn--icon"
      />
    </button>
    <button
      class="btn"
      [disabled]="last_page == fetch_page"
      (click)="pagination('1')"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="btn--icon"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap=" round"
          stroke-linejoin="round"
          d="M9 5l7 7-7 7"
        />
      </svg>
    </button>
  </div>
</div>
